import axios from 'axios';
import snakeobj from 'snakeobj';
import camelobj from 'camelobj';
import { get } from 'lodash';
import uuid from 'uuid/v4';
import storage from './storage';
import detectLanguage from './detect-language';
import { getParameterByName } from './functions';

const env = global.pbgEnv;
const { REACT_APP_EVENTS_API_HOST, REACT_APP_PBG_API_ACCESS_KEY } = env;

const eventsApi = axios.create();

export const EVENT_CLAIM_LOADED = 'purchase_claim_loaded';
export const EVENT_DASHBOARD_COMMIT_LOADED = 'purchase_dashboard_commit_loaded';
export const EVENT_DASHBOARD_LOADED = 'purchase_dashboard_loaded';
export const EVENT_LANGUAGE_CHANGED = 'user_language_selected';
export const EVENT_PURCHASE_CLAIM_CLOSED = 'purchase_claim_closed';
export const EVENT_PURCHASE_CLAIMED = 'purchase_claimed';

eventsApi.defaults.baseURL = REACT_APP_EVENTS_API_HOST;
eventsApi.defaults.headers.common['Content-Type'] = 'application/json';
eventsApi.defaults.headers.common.Accept = 'application/json';
eventsApi.defaults.transformRequest = [
  ...axios.defaults.transformRequest,
  (data) => {
    if (!data) return undefined;
    if (data instanceof FormData) return data;
    return JSON.stringify(snakeobj(JSON.parse(data)));
  },
];
eventsApi.defaults.transformResponse = [
  ...axios.defaults.transformResponse,
  data => camelobj(data),
];

eventsApi.interceptors.request.use(
  (config) => {
    const newConfig = { ...config };
    const language = detectLanguage();

    if (config.authorization && config.authorization.bearer) {
      newConfig.headers.Authorization = `Bearer ${config.authorization.bearer}`;
    } else {
      const origin = `${window.location.protocol}//${window.location.host}`;
      const payload = btoa(`${REACT_APP_PBG_API_ACCESS_KEY} ${origin}`);
      newConfig.headers.Authorization = `Digest ${payload}`;
    }

    newConfig.headers['Access-Control-Expose-Headers'] = 'Session-Id, X-UPDATED-JWT, X-Invalid-Auth-Token';

    if (language) {
      newConfig.headers['Accept-Language'] = language;
    }

    return newConfig;
  },
  error => error,
);

eventsApi.interceptors.request.use(
  (config) => {
    const newConfig = { ...config };
    const sessionId = getParameterByName('sessionId') || storage.getItem('sessionId') || uuid();

    storage.setItem('sessionId', sessionId);
    newConfig.headers['Session-Id'] = sessionId;

    return newConfig;
  },
  error => error,
);

eventsApi.interceptors.response.use(
  response => response,
  (error) => Promise.reject(error),
);

eventsApi.interceptors.response.use(
  (response) => {
    const headers = response.headers;

    if (headers['x-updated-jwt']) {
      const user = storage.getItem('auth');

      if (user) {
        user.accessToken = headers['x-updated-jwt'];
        storage.setItem('auth', user);
      }
    }
    return response;
  },
  (error) => {
    const headers = get(error, 'response.headers', {});

    if (headers['x-invalid-auth-token']) {
      storage.removeItem('auth');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const publish = (name, entity, data) => {
  const authentication = storage.getItem('auth');
  const headers = {};
  if (authentication) {
    headers.authorization = { bearer: authentication.accessToken };
  }
  const payload = {
    name,
    sessionId: storage.getItem('sessionId'),
    applicationName: 'varys',
    applicationVersion: null, // git revision from env variable, pending.
    ...entity,
    data,
  };

  return eventsApi.post('/', payload, headers)
}

export default {
  publish,
};



// WEBPACK FOOTER //
// ./src/lib/events.js